import React from 'react';

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const localToday = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };

const STATUS_CLS = {
  Draft: 'bg-slate-100 text-slate-700 border-slate-300',
  'Pending Approval': 'bg-amber-100 text-amber-800 border-amber-300',
  Rejected: 'bg-red-100 text-red-800 border-red-300',
  Issued: 'bg-blue-100 text-blue-800 border-blue-300',
  'Partially Received': 'bg-violet-100 text-violet-800 border-violet-300',
  Received: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  Closed: 'bg-slate-200 text-slate-700 border-slate-400',
  Canceled: 'bg-red-50 text-red-700 border-red-200',
  Void: 'bg-white text-slate-400 border-slate-300 line-through',
};

export const PoStatusBadge = ({ status }) => (
  <span className={`inline-block text-[10px] font-semibold uppercase border rounded-sm px-1.5 py-0.5 ${STATUS_CLS[status] || STATUS_CLS.Draft}`} data-testid="po-status-badge">{status}</span>
);

export const PoTypeChip = ({ po }) => (
  <span className="inline-block text-[10px] font-bold uppercase rounded-sm px-1.5 py-0.5 text-white" style={{ background: po.po_type_color || '#475569' }} data-testid="po-type-chip">{po.po_type_label}</span>
);
